import {
    AttributionBudgetModelDto,
    CommissionMailModel,
    EditerExecutionAttributionAutoModel,
    ModeleEnveloppeDto,
    MutationEditerExecutionAttributionAutoArgs,
    MutationGetAttibutionBdgModelWithIdArgs,
    MutationGetExecutionAutoAttributionModelArgs,
    MutationGetListeCommissionMailArgs,
    MutationGetListeEnveloppeModeleGeneriqueArgs,
    MutationGetListeUsersMailArgs,
    MutationSaveAttributionBudgetArgs,
    MutationSupprimerAttributionBudgetArgs,
    UserCommissionDroit,
    UserEmailModel
} from 'src/graphql/generated-types';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import {
    SubventionAllocationArchiveAction,
    SubventionAllocationGetAction,
    SubventionAllocationLoadRelatedListAction,
    SubventionAllocationSaveAction,
    SubventionAllocationSaveAutomatedExecutionAction,
} from 'src/app/board/subvention/stores/subvention-allocation/subvention-allocation.action';
import gql from 'graphql-tag';
import { map, switchMap, tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Injectable } from '@angular/core';
import { UserState } from 'src/app/_user/store/user/user.state';
import { Observable, of } from 'rxjs';
import { allocationToXML } from 'src/app/board/subvention/stores/subvention-allocation/subvention-allocation.xml';


export class SubventionAllocationModel {

    allocation: AttributionBudgetModelDto = null;

    automatedAllocationExecution: EditerExecutionAttributionAutoModel = null;

    envelopesList: ModeleEnveloppeDto[] = [];

    commissionsList: CommissionMailModel[] = [];

    usersList: UserEmailModel[] = [];
}

@Injectable()
@State({
    name: 'subventionAllocation',
    defaults: new SubventionAllocationModel()
})
export class SubventionAllocationState {

    constructor(private readonly graphqlService: GraphqlService,
                private readonly store: Store) {
    }

    private get commissionsRightsList(): UserCommissionDroit[] {
        return this.store.selectSnapshot(UserState.commissionsRightsList);
    }

    @Selector()
    static allocation(state: SubventionAllocationModel): AttributionBudgetModelDto {
        return state.allocation;
    }

    @Selector()
    static automatedAllocationExecution(state: SubventionAllocationModel): EditerExecutionAttributionAutoModel {
        return state?.automatedAllocationExecution;
    }

    @Selector()
    static envelopesList(state: SubventionAllocationModel): ModeleEnveloppeDto[] {
        return state.envelopesList;
    }

    @Selector()
    static commissionsList(state: SubventionAllocationModel): CommissionMailModel[] {
        return state.commissionsList;
    }

    @Selector()
    static usersList(state: SubventionAllocationModel): UserEmailModel[] {
        return state.usersList;
    }

    @Selector()
    static isAllocationEnveloppeArchived(state: SubventionAllocationModel): boolean {
        return state.envelopesList.every(({Id}) => Id !== state.allocation?.EnveloppeModel?.Id);
    }

    @Action(SubventionAllocationLoadRelatedListAction)
    loadRelatedList({patchState}: StateContext<SubventionAllocationModel>) {

        type mutations = 'GetListeEnveloppeModeleGenerique' | 'GetListeCommissionMail' | 'GetListeUsersMail';
        type args =
            MutationGetListeEnveloppeModeleGeneriqueArgs
            | MutationGetListeCommissionMailArgs
            | MutationGetListeUsersMailArgs;

        return this.graphqlService.mutateMultiple<mutations, args>({
            mutation: gql`
                mutation loadRelatedListAllocation($contexte: ContextInfosInput, $critere: CriteresEnveloppeQuotaDTOInput, $listeIdCom: ArrayOfdecimalInput) {
                    GetListeEnveloppeModeleGenerique(contexte: $contexte, critere: $critere) {
                        ModeleEnveloppeDTO {
                            Id
                            Libelle
                            IsNominatif
                        }
                    }
                    GetListeCommissionMail(contexte: $contexte, listeIdCom: $listeIdCom) {
                        CommissionMailModel {
                            IdCommission
                            LibelleCommission
                            AdresseMail
                        }
                    }
                    GetListeUsersMail( contexte: $contexte) {
                        UserEmailModel {
                          IdUtilisateur
                          PrenomUtilisateur
                          NomUtilisateur
                          EmailProUtilisateur
                          EmailPersoUtilisateur
                        }
                    }
                }
            `,
            variables: {
                critere: {
                    IsEnveloppeForAttributionParam: true,
                    IsCloture: false
                },
                listeIdCom: {
                    decimal: this.commissionsRightsList.map(({IdCommission}) => IdCommission)
                }
            }
        }).pipe(
            tap(({
                     GetListeEnveloppeModeleGenerique,
                     GetListeCommissionMail,
                     GetListeUsersMail
                 }) => patchState({
                envelopesList: GetListeEnveloppeModeleGenerique?.ModeleEnveloppeDTO || [],
                commissionsList: GetListeCommissionMail?.CommissionMailModel || [],
                usersList: GetListeUsersMail?.UserEmailModel || []
            }))
        );
    }

    @Action(SubventionAllocationGetAction)
    getAllocation({patchState}: StateContext<SubventionAllocationModel>, {allocationId}: SubventionAllocationGetAction) {
        type mutation = 'GetAttibutionBDGModelWithId' | 'GetExecutionAutoAttributionModel';
        type variables = MutationGetAttibutionBdgModelWithIdArgs | MutationGetExecutionAutoAttributionModelArgs;

        if (!allocationId) {
            patchState({allocation: null, automatedAllocationExecution: null});
            return;
        }

        return this.graphqlService.mutateMultiple<mutation, variables>({
            mutation: gql`
                mutation GetAttibutionBDGModelWithId(
                    $contexte: ContextInfosInput,
                    $idAtb: Float
                ) {
                    GetAttibutionBDGModelWithId(
                        contexte: $contexte,
                        idAtb: $idAtb
                    ) {
                        Id
                        Libelle
                        IdEnveloppe
                        Code
                        IsNominative
                        DateValeurDefaut
                        IdAnneeRef
                        Description
                        IsCloture
                        IdDelegation
                        IsAttribBoule
                        EnveloppeModel {
                            Id
                            Libelle
                        }
                        ArticleModele {
                            ID
                            Libelle
                        }
                        IdRglAcc
                        MoteurRegleAcc {
                            Id
                            LibelleRegle
                            IsRegleAvancee
                            ModeleRegleAcc {
                                Id
                                IsNominative
                                IsConjointHandicape
                                IsEnfantDirect
                                IsEnfantHandicape
                                IsEnfantACharge
                                AgeEnfantMin
                                AgeEnfantMax
                                IdTypeDateRefAge
                                ModeAccess
                                IdtypeRefAnc
                                # Type de date Saisie
                                DateRefJour
                                DateRefMois
                                # Pour tous les ouvrants droits par ancienneté
                                RgModAccesAnMin
                                RgModAccesAnMax
                                # Variable selon critères
                                IdChamp
                                IdChampAD
                                ListeIdChampAD {
                                    decimal
                                }
                                ListeIdTypeBenef {
                                    decimal
                                }
                                ListeModeleRegleAccListeModele {
                                    RegleAccListeValModelDTO {
                                        IdValeurChamp
                                        AncienneteMinimum # Par ancienneté
                                        AncienneteMaximum # Par ancienneté
                                    }
                                }
                            }
                        }
                        IdRglSubQta
                        MoteurRegleSubQta {
                            Id
                            LibelleRegle
                            IsRegleAvancee
                            TypeRegle
                            ModeleRegleSubQta {
                                Id
                                IdTypeDateRefPond
                                DateRefPondJour
                                DateRefPondMois
                                # Variable selon critères
                                IdChamp
                                ListeModeleRegleSubQuotaValModele {
                                    RegleSubQuotaListeValModelDTO {
                                        Id
                                        ChpLstValId # Critère de type Liste
                                        De # Critère de type numérique
                                        A # Critère de type Numérique
                                        Od
                                        Conjoint
                                        Enfant
                                        Externe
                                        ValMin
                                        ValMax
                                    }
                                }
                                # Paramètres
                                RglModeleIdEnfDir
                                RglModeleIdEnfHan
                                RglModeleIdEnfAch
                                RglModeleSQMontant
                                RglModeleIdAgeEnfMin
                                RglModeleIdAgeEnfMax
                                IsPondererTempsTravail
                                IsPondererMoisPresence
                                IsPondererMoisEntier
                            }
                        }
                        ListeClesRepartition {
                            CleRepartitionModelDTO {
                                SectionAnalytique {
                                    Id
                                }
                            }
                        }

                        DateDernierMAJ

                        # Exécution
                        AttribTgExec
                        DateExec
                    }

                    GetExecutionAutoAttributionModel(contexte: $contexte, idAttrib: $idAtb) {
                        IdAttrib
                        IdContactParam
                        IsExecutionAuto
                        FrequenceExecution
                        ContactParam {
                            IdCE
                            IdCommission
                            IdUser
                            EmailLibre
                        }
                        NeedSendAlwaysReport
                    }
                }
            `,
            variables: {
                idAtb: allocationId
            }
        }).pipe(
            tap(({GetAttibutionBDGModelWithId, GetExecutionAutoAttributionModel}) => {
                patchState({
                    allocation: GetAttibutionBDGModelWithId,
                    automatedAllocationExecution: GetExecutionAutoAttributionModel
                });
            })
        );
    }

    @Action(SubventionAllocationSaveAction)
    saveAllocation(
        {dispatch}: StateContext<SubventionAllocationModel>,
        {model}: SubventionAllocationSaveAction
    ) {
        // Une attribution exécutée ne pourra pas être modifiée
        // Les seules modifications possibles concernent l'exécution automatique de l'attribution
        return model.allocation.AttribTgExec && !!model.automatedExecution
            ? this.editAutomatedExecution(model.automatedExecution)
            : this.editAllocation(model.allocation).pipe(
                switchMap((allocationId) => {
                    if (!!model.automatedExecution) {
                        return this.editAutomatedExecution({
                            ...model.automatedExecution,
                            IdAttrib: allocationId
                        });
                    }

                    return of(allocationId);
                }),
                switchMap(allocationId => this.store.dispatch(new SubventionAllocationGetAction(allocationId)).pipe(
                    map(() => allocationId)
                ))
            );
    }

    /**
     * On n'attend pas de retour de cet appel, mais une exception qui est récupérée dans le composant qui fait le dispatch
     */
    @Action(SubventionAllocationArchiveAction)
    archiveAllocation({}: StateContext<SubventionAllocationModel>, {allocationId}: SubventionAllocationArchiveAction) {
        return this.graphqlService.mutateOne<'SupprimerAttributionBudget', MutationSupprimerAttributionBudgetArgs>({
            mutation: gql`
                mutation SupprimerAttributionBudget($contexte: ContextInfosInput, $idAtb: Float) {
                    SupprimerAttributionBudget(contexte: $contexte, idAtb: $idAtb)
                }
            `,
            variables: {
                idAtb: allocationId
            }
        });
    }

    @Action(SubventionAllocationSaveAutomatedExecutionAction)
    saveAutomatedExecution({}: StateContext<SubventionAllocationModel>, {executionModel}: SubventionAllocationSaveAutomatedExecutionAction) {
        return this.editAutomatedExecution(executionModel).pipe(
            switchMap(id => this.store.dispatch(new SubventionAllocationGetAction(id))),
        );
    }

    editAllocation(allocation: AttributionBudgetModelDto): Observable<number> {
        return this.graphqlService.mutateOne<'SaveAttributionBudget', MutationSaveAttributionBudgetArgs>({
            mutation: gql`
                mutation SaveAttribution($contexte: ContextInfosInput, $rawXML: String) {
                    SaveAttributionBudget(contexte:$contexte,  rawXML: $rawXML)
                }
            `,
            variables: {
                rawXML: allocationToXML(allocation)
            }
        });
    }

    editAutomatedExecution(executionModel: EditerExecutionAttributionAutoModel): Observable<number> {
        return this.graphqlService.mutateOne<'EditerExecutionAttributionAuto', MutationEditerExecutionAttributionAutoArgs>({
            mutation: gql`
                mutation EditerExecutionAttributionAuto($contexte: ContextInfosInput, $execModel: EditerExecutionAttributionAutoModelInput) {
                    EditerExecutionAttributionAuto(contexte: $contexte, execModel: $execModel) {
                        IdAttrib
                    }
                }
            `,
            variables: {
                execModel: executionModel
            }
        }).pipe(
            map(EditerExecutionAttributionAuto => EditerExecutionAttributionAuto.IdAttrib)
        );
    }

}

